import React from 'react';
import { Modal } from 'semantic-ui-react';
import LadoBomLogo from '../../../../resources/imgs/logo-lado-bom-seguros.svg';
import { Body, Footer, FooterButton, Header, Heading, Logo, Notice } from './styles';

interface AlfaDiscontinuationNoticeModalProps {
  open: boolean;
  onClose: () => void;
}

const AlfaDiscontinuationNoticeModal = ({
  open,
  onClose
}: AlfaDiscontinuationNoticeModalProps): JSX.Element => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      size="small"
      closeOnEscape
      closeOnDocumentClick={false}
      closeOnDimmerClick={false}
      closeIcon
      style={{
        width: '540px',
        maxWidth: 'calc(100vw - 24px)',
        height: 'min(854px, calc(100vh - 16px))',
        maxHeight: 'calc(100vh - 16px)',
        padding: 0,
        overflow: 'hidden',
        borderRadius: '3px'
      }}
    >
      <Modal.Content style={{ height: '100%', padding: 0 }}>
        <Notice>
          <Header>
            <Heading>
              <span>Comunicado</span>
              <strong>Alfa Seguradora</strong>
            </Heading>
            <Logo src={LadoBomLogo} alt="Lado Bom Seguros" />
          </Header>

          <Body>
            <p>
              <b>Prezados,</b>
            </p>

            <p>
              Gostaríamos de compartilhar antecipadamente uma informação importante
              relacionada às carteiras de Seguro Incêndio atualmente operadas junto à Alfa
              Seguros.
            </p>

            <p>
              A Lado Bom recebeu de representantes da seguradora a sinalização de que a
              Alfa{' '}
              <strong>
                deverá descontinuar a comercialização do produto de seguro imobiliário.
              </strong>
            </p>

            <p>
              Até o momento, a seguradora ainda não publicou um comunicado oficial com as
              condições e as datas definitivas da transição. Segundo as informações
              preliminares que recebemos, essa formalização deverá ocorrer em breve.
            </p>

            <p>
              Nossa principal preocupação neste momento são as apólices com vigência
              mensal. Pelas informações recebidas até aqui, após a formalização da
              descontinuação poderá existir uma janela bastante curta para a manutenção
              dessas coberturas, o que exigirá a migração das carteiras para outras
              seguradoras.
            </p>

            <p>
              Por esse motivo, entendemos que não seria prudente aguardar o comunicado
              oficial para somente então iniciar esse trabalho.
            </p>

            <p>
              <strong>
                A Lado Bom já está preparada para essa mudança e conta com uma solução
                estruturada para a migração das carteiras.
              </strong>{' '}
              Nossa equipe está pronta para conduzir todas as etapas necessárias de forma
              segura e organizada, buscando garantir a continuidade das coberturas e
              minimizar qualquer impacto operacional para a imobiliária, os proprietários
              e os inquilinos.
            </p>

            <p>
              Também estamos trabalhando junto à Alfa para buscar um prazo de transição
              mais adequado, que permita realizar esse processo de forma organizada.
              Entretanto, até o momento, não recebemos uma definição formal sobre esse
              prazo.
            </p>

            <p>
              Por isso, nosso time entrará em contato com vocês para iniciarmos
              preventivamente o levantamento da carteira e a implementação da solução de
              migração mais adequada.
            </p>

            <p>
              Assim que a Alfa divulgar oficialmente as condições de encerramento do
              produto, enviaremos uma nova comunicação com as informações definitivas e o
              cronograma da transição.
            </p>

            <p>
              Contem com a Lado Bom para conduzir todo esse processo com segurança,
              agilidade e tranquilidade.
            </p>

            <p>Atenciosamente,</p>

            <p>Equipe Lado Bom Seguros</p>
          </Body>

          <Footer>
            <FooterButton type="button" aria-label="Confirmar leitura" onClick={onClose}>
              OK
            </FooterButton>
          </Footer>
        </Notice>
      </Modal.Content>
    </Modal>
  );
};

export default AlfaDiscontinuationNoticeModal;
